const localState = {
  accessToken: undefined,
  cart: [],
};

const registrationState = {
  registrationLoading: false,
  registrationParams: null,
  registrationError: null,
  registrationResponse: null,
};

const loginState = {
  loginLoading: false,
  loginParams: null,
  loginError: null,
  loginResponse: null,
};

const removeAccountState = {
  removeAccountLoading: false,
  removeAccountParams: null,
  removeAccountError: null,
  removeAccountResponse: null,
};

const clothesInquiryState = {
  clothesInquiryLoading: false,
  clothesInquiryParams: null,
  clothesInquiryError: null,
  clothesInquiryResponse: null,
};

const clothesEntityState = {
  clothesEntityLoading: false,
  clothesEntityParams: null,
  clothesEntityError: null,
  clothesEntityResponse: null,
};

const clothesInsertState = {
  clothesInsertLoading: false,
  clothesInsertParams: null,
  clothesInsertError: null,
  clothesInsertResponse: null,
};

const clothesUpdateState = {
  clothesUpdateLoading: false,
  clothesUpdateParams: null,
  clothesUpdateError: null,
  clothesUpdateResponse: null,
};

const clothesDeleteState = {
  clothesDeleteLoading: false,
  clothesDeleteParams: null,
  clothesDeleteError: null,
  clothesDeleteResponse: null,
};

export default {
    ...localState,
    ...registrationState,
    ...loginState,
    ...removeAccountState,
    ...clothesInquiryState,
    ...clothesEntityState,
    ...clothesInsertState,
    ...clothesUpdateState,
    ...clothesDeleteState,
};